export default __webpack_public_path__ + "static/media/img-5.7125efd1.jpg";